import React from 'react'
import { Row, Col } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
// import FileViewer from 'react-file-viewer'
// import PDFViewer from 'pdf-viewer-reactjs'
import Iframe from 'react-iframe'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'
import actions from 'redux/virtual/event/actions'
import './quickview.less'

@connect(({ virtualEvent }) => ({ virtualEvent }))
class DocumentList extends React.Component {
  goBack = () => {
    const { dispatch } = this.props
    dispatch({
      type: actions.SET_STATE,
      payload: {
        isQuickViewOpen: false,
        currentFile: {},
      },
    })
  }

  onError = err => {
    console.log('error in opening file')
    console.log(err)
  }

  render() {
    const {
      virtualEvent: { currentFile },
    } = this.props
    // const extension = currentFile.fileURL
    //   .substring(currentFile.fileURL.lastIndexOf('.') + 1)
    //   .toLowerCase()
    const extension = currentFile.fileURL
      .substring(currentFile.fileURL.lastIndexOf('.') + 1)
      .toLowerCase()
    const finalRender = []
    if (extension === 'pdf') {
      finalRender.push(
        <Iframe
          url={`https://docs.google.com/gview?url=${currentFile.fileURL}&embedded=true`}
          width="100%"
          height="600px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />,
      )
    } else if (extension === 'mp4') {
      finalRender.push(
        <ReactPlayer
          url={currentFile.fileURL}
          playing
          controls
          width="100%"
          height="100%"
          loop
          volume={1}
          style={{ backgroundColor: '0 0 0 0.5' }}
        />,
      )
    } else if (
      extension === 'jpg' ||
      extension === 'jpeg' ||
      extension === 'png' ||
      extension === 'gif'
    ) {
      finalRender.push(
        <img src={currentFile.fileURL} alt={currentFile.heading} style={{ width: '100%' }} />,
      )
    }
    return (
      <>
        <Row gutter={0} justify="space-around" align="middle" className="headerRow">
          <Col xs={3} md={6} lg={6} xl={6}>
            <LeftOutlined onClick={this.goBack} style={{ color: 'white', fontSize: '16px' }} />
          </Col>
          <Col xs={18} md={12} lg={12} xl={12} className="text-center">
            <h3>{currentFile.heading}</h3>
          </Col>
          <Col xs={3} md={6} lg={6} xl={6} />
        </Row>
        <Row gutter={0} justify="space-around" align="middle">
          <Col xs={24} md={24} lg={24} xl={24} className="text-center">
            {finalRender}

            {/* <PDFViewer
              document={{
                url: currentFile.fileURL,
              }}
            /> */}
            {/* <FileViewer
              fileType={extension}
              filePath={currentFile.fileURL}
              onError={this.onError}
            /> */}
          </Col>
        </Row>
      </>
    )
  }
}

export default DocumentList
